
import actions from './actions'

export default function extendStoreConfig (storeConfig) {
  storeConfig.actions = actions
  return storeConfig
}
